import axios from "../../../../axiosInstance";
import { CATEGORIES } from "../../../../constants/categories";
import { STATUSES } from "../../../../constants/statuses";

// Transform API data to component format
const transformValidationData = (apiData, requesProgressStatus) => {
  return apiData.map((member) => {
    // Get the latest review for this member (if any)
    const latestReview =
      member.committee_reviews && member.committee_reviews.length > 0
        ? member.committee_reviews[member.committee_reviews.length - 1]
        : null;

    // Construct reviewer name
    const reviewerName =
      member.first_name && member.last_name
        ? `${member.first_name} ${member.last_name}`
        : member.username || `Member ${member.id}`;

    // Determine status
    let status = requesProgressStatus && requesProgressStatus === STATUSES.COMMITTEE_REVIEW ? "In Review" : "-"; // default status
    if (latestReview) {
      switch (latestReview.review) {
        case "approved":
          status = "Approved";
          break;
        case "rejected":
          status = "Rejected";
          break;
        case "sendback":
          status = "Sent Back";
          break;
        default:
          status = "In Review";
      }
    }

    // Get process name from category (not username)
    const categoryName = member.end_users_category?.name || '';
    const process = CATEGORIES.ECTD_ASSESSMENT_CATEGORIES.includes(categoryName)
      ? "eCTD"
      : categoryName === CATEGORIES.INSPECTION_DEPARTMENT
        ? "Inspection"
        : categoryName === CATEGORIES.CONTROL_LAB_VALIDATION
          ? "Lab"
          : "Other";

    // Transform comments to the expected format
    const transformedComments = member.comments
      ? member.comments.map((comment) => ({
          id: comment.id,
          author: reviewerName, // Use the reviewer name as author
          date: new Date(comment.createdAt).toLocaleDateString('en-GB'),
          text: comment.comment,
          attachment: comment.additional_file
            ? {
                id: comment.additional_file.id,
                url:
                  comment.additional_file.file_path ||
                  `/api/uploads/${comment.additional_file.id}`, // Use file_path or fallback to generated URL
                name: comment.additional_file.original_name,
                size: comment.additional_file.file_size,
                type: comment.additional_file.mime_type,
                filePath: comment.additional_file.file_path,
                createdAt: comment.additional_file.createdAt,
              }
            : null,
        }))
      : [];

    const transformedDirectedComments =
      member.core_validator_directed_committee_comments
        ? member.core_validator_directed_committee_comments.map((comment) => {
            console.log("Transforming comment:", comment); // Debug log
            return {
              id: comment.id,
              author: reviewerName, // Use the reviewer name as author
              date: new Date(comment.createdAt).toLocaleDateString('en-GB'),
              text: comment.comment,
              attachment: comment.additional_file
                ? {
                    id: comment.additional_file.id,
                    url:
                      comment.additional_file.file_path ||
                      `/api/uploads/${comment.additional_file.id}`, // Use file_path or fallback to generated URL
                    name: comment.additional_file.original_name,
                    size: comment.additional_file.file_size,
                    type: comment.additional_file.mime_type,
                    filePath: comment.additional_file.file_path,
                    createdAt: comment.additional_file.createdAt,
                  }
                : null,
            };
          })
        : [];
    return {
      id: member.id,
      process: process,
      status: status,
      reviewer: reviewerName,
      comments: transformedComments, //transformedDirectedComments, // Use actual comments from API
      originalData: member, // Keep original data for reference
    };
  });
};

// API functions
export const apiService = {
  // Fetch validation records
  getValidationRecords: async (requestProgressId, requesProgressStatus) => {
    try {
      console.log("called getValidationRecords with ID:", requestProgressId);
      // Fetch data from actual API
      const response = await axios.get(
        `/api/core-validator-directed-committee-comments/committee-members-with-comments/${requestProgressId}`
      );
      const committeeCommentsAndReviews = response.data;

      // Transform API data to component format
      return transformValidationData(committeeCommentsAndReviews, requesProgressStatus);
    } catch (error) {
      console.error("Error fetching validation records:", error);
      // Fallback to mock data in case of error
      return [];
    }
  },

  // Submit a new comment with optional file attachment
  submitComment: async (
    memberId,
    requestProgressId,
    commentText,
    file = null
  ) => {
    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("committee_member_id", memberId);
      formData.append("request_progress_id", requestProgressId);
      formData.append("comment", commentText);

      if (file) {
        formData.append("attachment", file);
      }

      console.log("API: Submitting comment with data:", {
        committee_member_id: memberId,
        request_progress_id: requestProgressId,
        comment: commentText,
        hasFile: !!file,
        fileName: file?.name,
      });

      const response = await axios.post(
        "/api/core-validator-directed-committee-comments/core",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting comment:", error);
      throw error;
    }
  },

  // Switch request progress to assessment reviews
  switchToCommittee: async (requestProgressId) => {
    try {
      const requestBody = {
        action: "committee",
        requestsProgressId: requestProgressId,
      };

      const response = await axios.post(
        "/api/requests-progress/switch",
        requestBody
      );
      return response.data;
    } catch (error) {
      console.error("Error switching to committee:", error);
      throw error;
    }
  },
};
